import * as pathToRegexp from 'path-to-regexp'
import routeConfig from '../constants/routeConfig'

const routeUtils = {
  // 判断是否存在路由
  canMatchRoute: function (router, path) {
    return router.getMatchedComponents(path).length > 0
  },
  // 获取组件匹配的位置
  getRouteMatchIndex: function (vm) {
    let currentInstance = vm
    while (currentInstance) {
      let vNode = currentInstance.$vnode
      if (vNode && vNode.data && vNode.data.routerView) {
        return vNode.data.routerViewDepth
      }
      currentInstance = currentInstance.$parent
    }
    return -1
  },
  // 获取当前路由组件
  getRouteComponent: function (vm) {
    let currentInstance = vm
    while (currentInstance) {
      let vNode = currentInstance.$vnode
      if (vNode && vNode.data && vNode.data.routerView) {
        return currentInstance
      }
      currentInstance = currentInstance.$parent
    }
    return null
  },
  // 获取直接组件匹配的位置
  getInstanceMatchIndex: function (vm) {
    let getMatchIndex = -1
    let vNode = vm.$vnode
    if (vNode && vNode.data && vNode.data.routerView) {
      getMatchIndex = vNode.data.routerViewDepth
    }
    return getMatchIndex
  },
  // 获取组件匹配的信息
  getRouteMatch: function (vm, route) {
    let matchIndex = this.getRouteMatchIndex(vm)
    if (matchIndex >= 0) {
      return route.matched[matchIndex]
    } else {
      return null
    }
  },
  // 获取组件父路由匹配的信息
  getParentRouteMatch: function (vm, route) {
    let matchIndex = this.getRouteMatchIndex(vm)
    if (matchIndex > 0) {
      return route.matched[matchIndex - 1]
    } else {
      return null
    }
  },
  // 获取组件子路由匹配的信息
  getChildRouteMatch: function (vm, route) {
    let matchIndex = this.getRouteMatchIndex(vm)
    let routeMatches = route.matched
    if (matchIndex >= 0 && matchIndex < routeMatches.length - 1) {
      return routeMatches[matchIndex + 1]
    } else {
      return null
    }
  },
  // 获取匹配的路由标识
  getMatchId: function (route, match) {
    // 获取到匹配项
    if (match) {
      let path = match.path
      if (match.parent) {
        let parentPath = match.parent.path
        path = path.substring(parentPath.length)
      }
      return this.getRawMatchPath(route, match, path)
    }
  },
  // 获取组件父路由标识
  getParentRouteMatchId: function (vm, route) {
    let getMatch = this.getRouteMatch(vm, route)
    return this.getMatchId(route, getMatch)
  },
  // 获取组件路由标识
  getRouteMatchId: function (vm, route) {
    let matchIds = []
    let getMatch = this.getChildRouteMatch(vm, route)
    let matchId = this.getMatchId(route, getMatch)
    if (matchId) {
      // 仅当路由为最后一级时有效
      let routeMatches = route.matched
      if (getMatch === routeMatches[routeMatches.length - 1]) {
        let redirectId = route.query[routeConfig.Redirect.id]
        if (redirectId) {
          matchIds.push(redirectId)
        }
      }
      matchIds.push(matchId)
    }
    return matchIds
  },
  // 获取组件父路由路径
  getParentRoutePath: function (vm, route) {
    let getMatch = this.getParentRouteMatch(vm, route)
    if (getMatch) {
      return this.getRawMatchPath(route, getMatch, getMatch.path)
    }
  },
  // 获取组件路由路径
  getCurrentRoutePath: function (vm, route) {
    let getMatch = this.getRouteMatch(vm, route)
    if (getMatch) {
      return this.getRawMatchPath(route, getMatch, getMatch.path)
    }
  },
  // 获取子一级路由路径
  getChildRoutePath: function (vm, route) {
    let getMatch = this.getChildRouteMatch(vm, route)
    if (getMatch) {
      return this.getRawMatchPath(route, getMatch, getMatch.path)
    }
  },
  // 获取直接组件父路径
  getInstanceParentPath: function (vm, route) {
    let routeMatches = route.matched
    let matchIndex = this.getInstanceMatchIndex(vm, routeMatches)
    let getMatch
    if (matchIndex > 0) {
      getMatch = routeMatches[matchIndex - 1]
    }
    if (getMatch) {
      return this.getRawMatchPath(route, getMatch, getMatch.path)
    }
  },
  // 获取绝对父路径
  getAbstractParentPath: function (route) {
    let routeMatches = route.matched
    let getMatch = routeMatches.find((match, index) => index === routeMatches.length - 2)
    if (getMatch) {
      return this.getRawMatchPath(route, getMatch, getMatch.path)
    }
  },
  // 获取query信息
  getRouteQueryString: function (route) {
    let query = route.query
    if (query) {
      let queryPiece = []
      Object.keys(query).forEach(key => {
        queryPiece.push(key + '=' + query[key])
      })
      if (queryPiece.length > 0) {
        return '?' + queryPiece.join('&')
      }
    }
    return ''
  },
  // 获取路由路径
  getRawMatchPath: function (route, match, path) {
    if (path) {
      return pathToRegexp.compile(path)(route.params)
    } else {
      return ''
    }
  }
}

export default routeUtils
